import React from 'react';
import { FiMessageSquare, FiSearch, FiStar, FiZap } from 'react-icons/fi';

export interface AmpPromptCard {
  id: string;
  icon: React.ReactNode;
  title: string;
  prompt: string;
  color: string;
}

export function buildAmpPrompts(amp: {
  name: string;
  description: string;
  color: string;
  prompt1?: string;
  prompt2?: string;
  prompt3?: string;
  prompt4?: string;
}): AmpPromptCard[] {
  const { name, description, color, prompt1, prompt2, prompt3, prompt4 } = amp;

  // Use custom prompts from API if available, otherwise use defaults
  return [
    {
      id: 'get-started',
      icon: React.createElement(FiMessageSquare, { size: 18 }),
      title: 'Get Started',
      prompt: prompt1 || `Help me get started with ${name}`,
      color,
    },
    {
      id: 'ask-question',
      icon: React.createElement(FiSearch, { size: 18 }),
      title: 'Ask a Question',
      prompt: prompt2 || (description
        ? `I have a question about: ${description.slice(0, 80)}`
        : `What can ${name} help me with?`),
      color: '#8b5cf6',
    },
    {
      id: 'explore',
      icon: React.createElement(FiZap, { size: 18 }),
      title: 'Explore',
      prompt: prompt3 || `What are the main things ${name} can do for me?`,
      color: '#22d3ee',
    },
    {
      id: 'assist',
      icon: React.createElement(FiStar, { size: 18 }),
      title: 'Get Assistance',
      prompt: prompt4 || `Assist me with my current task using ${name}`,
      color: '#34d399',
    },
  ];
}
